export type WorksheetRefLinkState = 'ref_and_document' | 'ref_no_document' | 'document_no_ref';

export function resolveWorksheetRefLinkState(params: {
  hasRef: boolean;
  hasDocument: boolean;
}): WorksheetRefLinkState | null {
  if (params.hasRef && params.hasDocument) return 'ref_and_document';
  if (params.hasRef && !params.hasDocument) return 'ref_no_document';
  if (!params.hasRef && params.hasDocument) return 'document_no_ref';
  return null;
}

export function worksheetRefLinkStateLabel(state: WorksheetRefLinkState | null | undefined): string {
  switch (state) {
    case 'ref_and_document':
      return 'ref + 활동지';
    case 'ref_no_document':
      return 'ref만 (활동지 없음)';
    case 'document_no_ref':
      return '활동지만 (ref 없음)';
    default:
      return '—';
  }
}
